import React from "react";

import PeopleIcon from "@mui/icons-material/People";

function UsersIcon({ iconColor, iconSize = "small", ...other }) {
    return <PeopleIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default UsersIcon;
